<mat-grid-list class="color-picker" cols="{{ colors()?.length }}" gutterSize="5px">
  @for (color of colors(); track color) {
    <mat-grid-tile colspan="1" rowspan="1" [style.background]="color" (click)="onSelectColor(color)" [class.color-selected]="color === selectedColor()">
    </mat-grid-tile>
  }
</mat-grid-list>
